<template>
  <div :id="id" class="row">
    <LmTextInput
      ref="inputFocus"
      :id="`label-${id}`"
      class="col-12 col-md-4"
      v-model="component.componentProps.label"
      @input="onLabelChange($event)"
      :label="$t('title')"
      :placeholder="$t('title')"
      :help="$t('comp_title_help')"
    />
    <LmTextInput
      v-if="validateSuperUser"
      :id="`nombre-${id}`"
      class="col-12 col-md-4"
      v-model="component.formObjectToSendToServerProperty"
      @input="$emit('input', component); $emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
      :label="$t('name')"
      :placeholder="$t('name')"
      :help="$t('comp_name_help')"
    />
    <LmTextInput
      :id="`disabled-option-${id}`"
      class="col-12 col-md-4"
      v-model="component.componentProps.options.disabledOption"
      @input="$emit('input', component)"
      :label="$t('placeholder')"
      :placeholder="$t('placeholder')"
      :help="$t('comp_placeholder_help')"
    />
    <LmTextInput
      class="col-12 col-md-8"
      :id="id + 'help'"
      v-model="component.componentProps.help"
      @input="$emit('input', component)"
      :label="$t('helper_text_setter')"
      :placeholder="$t('helper_text_setter')"
      :help="$t('helper_text_setter_help')"
    />
    <LmSelect
      :id="id + 'css'"
      class="col-12 col-md-4"
      v-model="component.class"
      :options="{
        content: [
          {value: 'col-12 col-md-3',text: '25%'},
          {value: 'col-12 col-md-6', text: '50%'},
          {value: 'col-12 col-md-9', text: '75%'},
          {value: 'col-12 col-md-12', text: '100%'}
        ]
      }"
      :label="$t('desktop_view_width')"
      :help="$t('help_width_form_element')"
      @input="$emit('input', component)"
    />
    <div class="col-12">
      <h5>{{ $t('settings') }}</h5>
        <div
          v-for="(option, index) in component.componentProps.options.content"
          :key="index"
          class="row align-items-center"
          >
          <LmTextInput
            :id="`name-${id}-${index}`"
            class="col-12 col-md-5"
            v-model="component.componentProps.options.content[index].name"
            @input="onOptionTextChange($event, index)"
            :label="$t('text')"
            :placeholder="$t('text')"
          />
          <LmTextInput
            :id="`id-${id}-${index}`"
            class="col-12 col-md-5"
            v-model="component.componentProps.options.content[index].id"
            @input="$emit('input', component)"
            :label="$t('value')"
            :placeholder="$t('value')"
          />
          <font-awesome-icon
            :id="`trash-icon-${index}`"
            v-if="isAtLeastOneOption"
            class="clickable mt-3 col-12 col-md-1"
            icon="trash"
            @click="removeOption(index)" />
        </div>
        <LmButton
          :id="`lm-button-${id}`"
          type="button"
          :value="$t('add_option')"
          @click.native="addOption" />
    </div>
    <hr class="w-100 mx-2">
    <div class="col-12">
      <h5>{{ $t('validations') }}</h5>
      <div class="row align-items-center">
        <LmCheckbox
          class="col-12 col-md-4"
          :labelSingle="$t('required')"
          v-model="validations.required"
          @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
        />
      </div>
    </div>
    <hr class="w-100 mx-2">
    <LmConditionalBuilderUi
      v-if="isVisibleCondition"
      class="col-12"
      :id="id"
      :leftValueToCompareOptions="leftValueToCompareOptions"
      :visibilityDependOnConditions="visibilityDependOnConditions"
      @changeVisibilityDependOnConditions="component.visibilityDependOnConditions = $event"
      @input="$emit('input', component)"
      />
    <LmConditionalByEditModeBuilderUi
      :component="component"
      @input="$emit('input', component)"
      />
  </div>
</template>

<script>
import LmButton from '@/components/form/elements/LmButton'
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'
export default {
  mixins: [lmFormElementsBuilderUiMixin],
  data () {
    return {
      validations: {
        required: false
      }
    }
  },
  components: {
    LmButton
  },
  computed: {
    isAtLeastOneOption () {
      return this.component.componentProps.options.content.length > 1
    }
  },
  methods: {
    addOption () {
      this.component.componentProps.options.content.push({ id: '', name: '' })
    },
    removeOption (optionIndex) {
      this.component.componentProps.options.content.splice(optionIndex, 1)
    },
    onOptionTextChange (event, index) {
      this.component.componentProps.options.content[index].id = this.nameFormatter(event)
      this.$emit('input', this.component)
    }
  },
  watch: {
    componentData () {
      this.component = this.componentData
    }
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    }
  }
}
</script>
